import React from 'react';
import { ViewPage as ViewPageCommon } from '@atlassian/embedded-confluence-common';
import { withAnalyticsListener } from '../analytics';
import { I18nProvider } from '../page-common/I18nProvider';
var ViewPage = function ViewPage(props) {
  return /*#__PURE__*/React.createElement(I18nProvider, {
    locale: props.locale
  }, /*#__PURE__*/React.createElement(ViewPageCommon, props));
};
export default withAnalyticsListener(ViewPage);